module.exports = __webpack_public_path__ + "static/media/netflix.a9ff4b17.svg";